import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

export const onboardingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/onboarding',
  component: Onboarding,
});

function Onboarding() {
  return (
    <section>
      <h1 style={{ marginTop: 0 }}>Onboarding</h1>
      <p style={{ color: '#666' }}>
        Scaffold — wizard with extension + helper install + first-meeting hook lands in WEB-007 /
        BETA-103.
      </p>
      <ol>
        <li>Sign in (done if you can see this page)</li>
        <li>Install the browser extension (Chrome / Edge)</li>
        <li>Install the desktop helper (optional)</li>
        <li>Pair the helper</li>
        <li>Add your first directory</li>
        <li>Create your first topic group</li>
      </ol>
    </section>
  );
}
